module.exports = __webpack_public_path__ + "static/media/2.40fac289.png";